import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Leaf } from "lucide-react";
import { CONTATO } from "@/data/cabanas";

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-cdb-forest text-cdb-cream mt-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        <span className="w-10 h-10 rounded-full bg-cdb-cream/10 flex items-center justify-center">
                            <Leaf className="w-5 h-5 text-cdb-cream" />
                        </span>
                        <span className="text-xl font-bold">Cabanas da Barra</span>
                    </div>
                    <p className="text-sm text-cdb-cream/80 leading-relaxed max-w-sm">
                        Refúgio para casais cercado pela Mata Atlântica em Barra de Guaratiba, Rio de Janeiro.
                        Simplicidade, conforto e a privacidade que a natureza oferece.
                    </p>
                </div>

                <div>
                    <h4 className="text-lg font-bold mb-4">Navegação</h4>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/" className="hover:text-cdb-gold transition-colors">Início</Link></li>
                        <li><Link to="/cabanas" className="hover:text-cdb-gold transition-colors">Cabanas</Link></li>
                        <li><Link to="/reservas" className="hover:text-cdb-gold transition-colors">Reservas</Link></li>
                        <li><Link to="/faq" className="hover:text-cdb-gold transition-colors">FAQ</Link></li>
                        <li><Link to="/contato" className="hover:text-cdb-gold transition-colors">Contato</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-lg font-bold mb-4">Contato</h4>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-start gap-3">
                            <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                            <span>{CONTATO.endereco}</span>
                        </li>
                        <li className="flex items-center gap-3">
                            <Phone className="w-4 h-4" />
                            <a
                                href={`https://wa.me/${CONTATO.whatsapp}`}
                                target="_blank"
                                rel="noreferrer"
                                className="hover:text-cdb-gold"
                            >
                                {CONTATO.telefone}
                            </a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail className="w-4 h-4" />
                            <a href={`mailto:${CONTATO.email}`} className="hover:text-cdb-gold">
                                {CONTATO.email}
                            </a>
                        </li>
                        <li className="text-xs text-cdb-cream/60 pt-2 border-t border-cdb-cream/10">
                            CNPJ: {CONTATO.cnpj}
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-cdb-cream/10">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 text-xs text-cdb-cream/60 text-center">
                    © {new Date().getFullYear()} Cabanas da Barra. Todos os direitos reservados.
                </div>
            </div>
        </footer>
    );
}
